import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@services/config/config.service';
import { LoggerService } from '@services/logger/logger.service';
import { firstValueFrom, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ValidateAuthResponse } from '../../interfaces/api/auth/validate-auth-response.interface';

@Injectable({
  providedIn: 'root'
})
export class ClaimService {
  config: any;

  constructor(private _http: HttpClient,
    private _config: ConfigService,
    private _loggerService: LoggerService
  ) { }


  /**
   */
  /* istanbul ignore next */
  async getTokenClaims() {
    const claim = await firstValueFrom(this._http.get<ValidateAuthResponse>(`/api/auth/validate`));

    return claim.token;
  }

  /**
   * @returns Observable
   */
  /* istanbul ignore next */
  getClaims(): Observable<ValidateAuthResponse> {
    this.config = this._config.config;

    return this._http.get<ValidateAuthResponse>(`/api/auth/validate`)
      .pipe(tap(_ => this._loggerService.log('User success login from MyId')));
  }
}
